import { IExternalIncidentParams, IGroupUsers } from '@logicmanager/common';
import { ExternalWebform, InternalWebform } from '../../components/webform';
import { IState } from '../../interfaces/state';
import * as Actions from '../../actions';
import * as ReactRedux from 'react-redux';
import * as React from 'react';
import * as Redux from 'redux';
import { IWebformProps } from '../../components/webform/interfaces';

function mapDispatchToProps(dispatch: Redux.Dispatch<any>): any {
    return {
        ...Redux.bindActionCreators({
            ...Actions.UI.Creators,
            ...Actions.Meta.Creators,
            ...Actions.Values.Creators
        }, dispatch),
        fetchingRequest: () => {
            dispatch({
                type: Actions.UI.Constants.FETCH_REQUEST
            });
        },

        fetchingSuccess: () => {
            dispatch({
                type: Actions.UI.Constants.FETCH_SUCCESS
            });
        },
        fetchingFailure: () => {
            dispatch({
                type: Actions.UI.Constants.FETCH_FAILURE
            });
        },
        noVisibilityRules: () => {
            dispatch({
                type: Actions.UI.Constants.NO_VISIBILITY_RULES
            });
        }
    };
}

function mapStateToProps(state: IState, ownProps: IWebformContainerProps): IWebformStateProps {
    return {
        ...ownProps,
        meta: state.meta,
        ui: state.ui,
        values: state.values,
        groupUsers: state.meta.groupUsers
    };
}

const Webform: React.FunctionComponent<IWebformProps> = (props: IWebformProps) => {
    return props.internal ?
    <InternalWebform  {...props} /> :
    <ExternalWebform {...props} />;
};

export const WebformContainer: React.ComponentClass<IWebformContainerProps>
    = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Webform);

export type IWebformStateProps = IWebformContainerProps & IState;

interface IWebformContainerProps {
    readonly history: any;
    readonly params?: IExternalIncidentParams;
    readonly internal?: boolean;
    readonly testId?: number;
    readonly entityTypeId?: string;
    readonly entityId?: string;
    readonly groupUsers?: IGroupUsers;
    onCloseModal?(submit?: boolean): void;
}
